import React,{useEffect} from 'react';
import './ServicesPage.css';
import AOS from 'aos';

const TubeWellPumpServices = () => {
    useEffect(() => {
        AOS.init();
      
            window.scrollTo(0, 0)
        
      }, [])
  return (
    <div className='container-fluid' id='tube-well-pump-automation-services'>

    <div className="row first-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
      <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
          <h1>We Provides Top-notch <br />
          Tube Well/Pump Automation Services</h1>
          <p>" <b>Unique Technologies </b> specializes in delivering advanced Tube Well/Pump Automation Systems, leveraging cutting-edge technology to optimize water management processes, enhance efficiency, and ensure reliable operation, empowering clients to streamline operations and maximize resource utilization with ease and precision."</p>
      </div>
      <div className="col img-col"></div>
    </div>
    <div className="row top-heading-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
          <h2>Our Six Step <br />
          working Process for Street Light <br /> Automation Services</h2>
          <p>Certainly, here's a six-step working process for your Tube Well/Pump Automation System offered by Unique Technologies</p>
      </div>
  <div className="row second-row">
   <div className="col oddcol first-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
      <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>1.Site Assessment and Requirements Gathering:  </h3>
              <p>Our team conducts a thorough evaluation of the site, including water source characteristics and client requirements, to determine the optimal automation solution.</p>
          </div>
          <div className="col first-img-col"></div>
      </div>
   </div>
   <div className="col evencol second-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col second-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>2.Customized System Design:  </h3>
              <p>Based on the site assessment, we design a bespoke automation system tailored to the specific needs of the tube well or pump, incorporating sensors, controllers, and communication technologies for efficient operation.</p>
          </div>

      </div>
   </div>
   <div className="col oddcol third-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>3.Installation and Integration: </h3>
              <p>Our skilled technicians install the automation hardware, seamlessly integrating it with the tube well or pump infrastructure and electrical systems, ensuring compatibility and minimal disruption to operations..</p>
          </div>
          <div className="col third-img-col"></div>
      </div>
   </div>
   <div className="col evencol fourth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col fourth-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>4.Programming and Calibration: </h3>
              <p>Following installation, our engineers program and calibrate the system to ensure precise control over pumping operations, adjusting parameters such as water flow rates, pressure levels, and scheduling as per client requirements.</p>
          </div>

      </div>
   </div>
   <div className="col oddcol fifth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>5.Testing and Optimization:  </h3>
              <p>Rigorous testing is conducted to validate the functionality and performance of the automation system under various operating conditions, fine-tuning settings to maximize efficiency, reliability, and resource utilization.</p>
          </div>
          <div className="col fifth-img-col"></div>
      </div>
   </div>
   <div className="col evencol sixth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col sixth-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>6.Training and Maintenance Support: </h3>
              <p>We provide comprehensive training for operators and maintenance personnel on system operation, troubleshooting, and preventive maintenance procedures. Additionally, our dedicated support team offers ongoing assistance and remote monitoring to ensure uninterrupted performance and timely resolution of any issues.</p>
          </div>

      </div>
   </div>
  </div>
  </div>
  )
}

export default TubeWellPumpServices
